
import React from "react";
import { Link } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface AdMaterialUrlProps {
  form: any;
  isEdit?: boolean;
}

const AdMaterialUrl: React.FC<AdMaterialUrlProps> = ({ form, isEdit = false }) => {
  const materialUrlValue = form.watch("materialUrl");
  
  React.useEffect(() => {
    console.log("Material URL value changed in form state:", materialUrlValue);
  }, [materialUrlValue]);

  return (
    <div className="space-y-2 mb-4">
      <Label htmlFor={isEdit ? "edit-materialUrl" : "materialUrl"} className="text-sm font-medium flex items-center gap-2">
        Material del anuncio
        <Link className="h-3 w-3 text-gray-500" />
      </Label>
      <Input 
        id={isEdit ? "edit-materialUrl" : "materialUrl"} 
        placeholder="https://ejemplo.com/imagen-o-video-del-anuncio" 
        {...form.register("materialUrl")}
        className="border-gray-300 text-sm h-9"
      />
      <p className="text-xs text-muted-foreground">
        Añade un enlace al material del anuncio (imagen, video, etc.)
      </p>
      {form.formState.errors.materialUrl && (
        <p className="text-xs text-red-500">{form.formState.errors.materialUrl.message?.toString()}</p>
      )}
    </div>
  );
};

export default AdMaterialUrl;
